import React from 'react';
import Table from './components/Table';
import './styles/attributes.css';

function App() {
  return <Table />;
}

export default App;
